import image from './images.js'
import upload from './upload'
import uploadPrivate from './uploadPrivate'
import vuet from '@/vuet'

function isWxClient() {
  var ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  }
  return false
};

export default {
  error: '',
  addRoutes: true,
  /** 有一部分路由根据登录身份动态加载，如果用户直接访问动态加载得路由，会匹配不到，这时候可以先跳一个专门页面加载路由，
   在跳指定路由；如果addRoutes为true，表示加载动态路由后还是没有，就说明路由不存在***/
  authhost: 'https://oauth.sunagy.com',
  apihost: "https://api-15.sunagy.com/api",

  // authhost: 'http://192.168.0.161:7001',
  // apihost: "http://192.168.0.161:8002/api",

  starturl: '', // 打开页面时的url,回退时根据此url判断是否已经回退到起始页，如果已经回退到起始页，则回退app页面
  firsturl: window.location.href.split('#')[0],
  localStorageKey: 'sunagy.srcd.community',
  host: 'https://15.sunagy.com',
  userinfo: {
    login_status: 0,//0 :未进行任何验证，1：微信授权成功未查询到账号, 2:登录成功
    token: '',
    nickName: '',
    gender: 1,
    age: 0,
    birthday: '',
    logo: '',
    communityCode: '',
    communityName: '',
    mazId: ''
  },
  bMap: {
    ak: 'xZhQho1zYDrTT4RaoO18E7z2KCR0Wab4',
    eventbus: new Vue()
  },
  location: {
    lng: 121.23721892443629,
    lat: 31.022366234667746,
    cityName: '上海市',
    cityCode: 310000,
    // 百度地图定位坐标，与当前设置不相同时提示是否切换城市
    exChange: false,
    b_cityName: '',
    b_cityCode: '',
    b_lng: '',
    b_lat: ''
  },
  ssb: {
    isSSB: true,
    error: '',
    thirdId: '',
    appid: 'PPCLNgGLgJ'
  },
  wx: {
    isWX: isWxClient(),
    isWXMini: window.__wxjs_environment === 'miniprogram',
    code: '',
    unionid: '',
    openid: '',
    inviteId: '',
    appid: 'wx961de68d82e9c6b1',
    signUrl: '',
    signData: null
  },
  setUserInfo(data) {
    for (var key in data) {
      this.userinfo[key] = data[key]
    }
  },
  clearUserInfo() {
    this.userinfo.token = '';
    this.userinfo.login_status = 0;
    localStorage.removeItem(this.localStorageKey)
  },
  setToken(token) {
    this.userinfo.token = token;
    localStorage.setItem(this.localStorageKey, token)
  },
  showlogin() {
    return new Promise((resolve, reject) => {
      var m = vuet.store.root;
      m.showLogin = true;
      m.login_callback = (v) => {
        if (!v) {
          this.userinfo.login_status = 0;
        }
        resolve(v);
      }
    })
  },
  img: image,
  upload: upload,
  uploadPrivate: uploadPrivate
}
